// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"LU","skip_info":"MU","skipped":"NU","modify_order":"OU","cancel_subscription_btn":"PU","byb":"QU","modify_order_outer":"RU","byb_edit_btn":"SU","modify_order_item":"TU","cancel_copy_wrapper":"UU","cancelled_copy":"VU"};
    if(module.hot) {
      // 1714422957440
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  